const scriptIconsMap = {
    bitcoin: 'script-bitcoin',
    bitcoin_questions: 'script-bitcoin',
    calculator: 'script-calculator',
    yoda: 'script-yoda',
    weather: 'script-weather',
    calendar: 'script-calendar',
    coffee: 'script-coffee',
    customer_feedback: 'script-customer-feedback',
    navigate: 'script-directions',
    food_ordering: 'script-food-ordering',
    hello: 'script-hello',
    jeopardy_game: 'script-jeopardy',
    jeopardy_data: 'script-jeopardy',
    news: 'script-news',
    sap_deliveries_data: 'script-sap',
    sap_deliveries_logic: 'script-sap',
    smalltalk: 'script-small-talk',
};

function getPredefinedScriptIcon(scriptName: string) {
    return scriptIconsMap[scriptName.substring(0, scriptName.indexOf('.at.js'))] || 'script-default';
}

export default getPredefinedScriptIcon;
